import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default () => {
  const swiperHeroHalf = new Swiper('.swiper-hero-half', {
    modules: [Pagination],    
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    slidesPerGroup:1,
    spaceBetween:0,
    pagination: {
      el:'.swiper-pagination-hero-half',
      clickable: true,
      renderBullet: function () {
        return '<span class="swiper-pagination-bullet">'+"</span>";
      },
    },
  });
  const swiperHeroFull = new Swiper('.swiper-hero-full', {
    modules: [Pagination],    
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    slidesPerGroup:1,
    spaceBetween:0,
    pagination: {
      el:'.swiper-pagination-hero-full',
      clickable: true,
      renderBullet: function () {
        return '<span class="swiper-pagination-bullet">'+"</span>";
      },
    },
  });
  const swiperSpotlight = new Swiper('.spotlight__slider', {
    modules: [Pagination],    
    direction: 'horizontal',
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween:24,
    pagination: {
      el:'.swiper-pagination-spotlight',
      clickable: true,
      renderBullet: function () {
        return '<span class="swiper-pagination-bullet">'+"</span>";
      },
    },
  });
  const swiperTestimonials = new Swiper('.testimonials__slider', {
    modules: [Navigation, Pagination],    
    direction: 'horizontal',
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween:32,
    pagination: {
      el:'.testimonials__pagination',
      clickable: true,
      renderBullet: function () {
        return '<span class="swiper-pagination-bullet">'+"</span>";
      },
    },
    navigation: {
      nextEl: ".testimonial-button-next",
      prevEl: ".testimonial-button-prev",
    }, 
  });

  const swiperNewArrivals = new Swiper('.new-arrivals-carousel', { 
    direction: 'horizontal',
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween:24,
  });

  const swiperLifeAt = new Swiper('.life-at-swiper', {
    modules: [Pagination],    
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    slidesPerGroup:1,
    spaceBetween: 24,
    centerInsufficientSlides: true,
    centeredSlides: true,
    wrapperClass: "life-at-swiper-wrapper",
    pagination: {
      el:'.life-at-swiper-pagination',
      clickable: true,
      renderBullet: function () {
        return '<span class="swiper-pagination-bullet">'+"</span>";
      },
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        slidesPerGroup:1,
        spaceBetween: 24,
        centerInsufficientSlides: false,
        centeredSlides: false,
      },
    }
  });

  const swiperCatalogueList = new Swiper('.item-list-cards__carousel', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup:1,
    spaceBetween: 16,
    centerInsufficientSlides: true,
    wrapperClass: "item-list-cards__wrapper",
  });

  
  let imgLeftContainers = document.querySelectorAll('.image-left-grey-bg__img');
  imgLeftContainers.forEach(cont => {    
    const imgLeftSwiper = new Swiper(cont, {
      modules: [Pagination],    
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerGroup:1,
      spaceBetween: 16,
      centerInsufficientSlides: true,
      wrapperClass: "image-left-swiper-wrapper",
      pagination: {
        el:'.image-left-swiper-pagination',
        clickable: true,
        renderBullet: function () {
          return '<span class="swiper-pagination-bullet">'+"</span>";
        },
      },
    });
  });

  const swiperSpaces = new Swiper('.space-info__images', {
    modules: [Navigation, Pagination],    
    direction: 'horizontal',
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween:32,
    pagination: {
      el:'.space-info__images__pagination',
      clickable: true,
      renderBullet: function () {
        return '<span class="swiper-pagination-bullet">'+"</span>";
      },
    },
    navigation: {
      nextEl: ".space-info__images__button-next",
      prevEl: ".space-info__images__button-prev",
    }, 
  });




  // ------------------ MOBILE SWIPERS ----------------- //

  if(window.innerWidth <= 1024){

    setTimeout(()=>{
      let discoverSwiper = document.querySelectorAll('.discover-services__swiper');
      discoverSwiper.forEach(el => {
        const swiperDiscover = new Swiper(el, {
          modules: [Pagination],    
          direction: 'horizontal',
          loop: false,
          slidesPerView: 1,
          slidesPerGroup:1,
          spaceBetween: 24,
          centeredSlides: true,
          wrapperClass: "discover-services__swiper-wrapper",
          pagination: {
            el:'.discover-services__swiper-pagination',
            clickable: true,
            renderBullet: function () {
              return '<span class="swiper-pagination-bullet">'+"</span>";
            },
          },
        });
      });
    }, 1000);
    
    const swiperThirdWidth = new Swiper('.masonry-swiper', {
      modules: [Pagination],    
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerGroup:1,
      spaceBetween: 32,
      centeredSlides: true,
      wrapperClass: "masonry-swiper-wrapper",
      pagination: {
        el:'.masonry-swiper-pagination',
        clickable: true,
        renderBullet: function () {
          return '<span class="swiper-pagination-bullet">'+"</span>";
        },
      },
    });
    if(document.querySelector('.masonry-swiper')){
      const imgs = document.querySelector('.masonry-swiper-wrapper').querySelectorAll('img');
      imgs.forEach(img => {
        img.classList.add('swiper-slide');
      });
    }

    const swiperImageRightTextLeft = new Swiper('.img-right-text-left__swiper', {
      modules: [Pagination],    
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1.2,
      slidesPerGroup:1,
      spaceBetween: 24,
      // centeredSlides: true,
      wrapperClass: "img-right-text-left__swiper-wrapper",
      pagination: {
        el:'.img-right-text-left__pagination',
        clickable: true,
        renderBullet: function () {
          return '<span class="swiper-pagination-bullet">'+"</span>";
        },
      },
    });

  }
  // ------------------ MOBILE SWIPERS END ----------------- //
  
};